import React, {useState, useMemo, useRef, useCallback} from "react";
import { Grid } from "@mui/material";
import SortFilter from "../../SortFilter/SortFilter";
import { interchangeSortByFields } from "./data";
import { getAllLocationsByBuyer } from "../../location/requests/location-requests";
import useGetRequestBody from "../../../hooks/useGetRequestBody";
import {withSnackbar} from "../../hocs/withSnackbar";

const ReviewAndCorrectSortFilter = ({
    setQuery,
    initialQuery,
    setStartDate,
    setEndDate,
    setSort,
    snackbarShowMessage,
}) => {

  const [orderNumber, setOrderNumber] = useState(initialQuery.orderNumber);
  const [equipmentNumber, setEquipmentNumber] = useState(initialQuery.equipmentNumber);

  const buyerLocations = useGetRequestBody(getAllLocationsByBuyer, useMemo(() => [], []), snackbarShowMessage);

  const locations = useMemo(() => {
    return [{id: "", locationName: "All"}, ...buyerLocations];
  },[buyerLocations]);

  const initialRender = useRef(true);

  const handleCallback = useCallback((e) => {
    const {location, startDate, endDate, filters, sortBy, sortDir} = e;

    if (!initialRender.current) {
        setSort(prev => ({...prev, value: sortBy, direction: sortDir}));
        setStartDate(e.startDate);
        setEndDate(e.endDate);
        setOrderNumber(e.orderNumber);
        setEquipmentNumber(e.equipmentNumber);
        setQuery(prevState => {
          return {
            ...prevState,
            locationId: location.id,
            startDate: startDate,
            endDate: endDate,
            orderNumber: filters.find(filter => filter.name === 'orderNumber')?.value || '',
            equipmentNumber: filters.find(filter => filter.name === 'equipmentNumber')?.value || '',
            supplierName: filters.find(filter => filter.name === 'supplierName')?.value || '',
            sortBy: sortBy,
            sortDir: sortDir,
          }
        })
    } else {
        initialRender.current = false;
    }
  }, [setSort, setStartDate, setEndDate, setQuery]);

  const filterByOptions = [
    {
      name: 'orderNumber',
      numberField: true,
      label: 'Booking Number',
      value: orderNumber,
    },
    {
      name: 'equipmentNumber',
      numberField: false,
      label: 'Equipment Number',
      value: equipmentNumber,
    }
  ];

  return (
    <Grid item container spacing={2} direction={"column"}>
      <SortFilter
        filterCallback={handleCallback}
        sortByOption={interchangeSortByFields}
        filterByOption={filterByOptions}
        locations={locations}
        disableFuture={true}
        updateStartDateWithEndDate={true}
        defaultLocationId={initialQuery.locationId}
        defaultStartDate={initialQuery.startDate}
        defaultEndDate={initialQuery.endDate}
        defaultSortBy={initialQuery.sortBy}
        sortDir={initialQuery.sortDir}
      />
    </Grid>
  )
};

export default withSnackbar(ReviewAndCorrectSortFilter);
